import React, { useState, useEffect } from "react";
import { Wallet, initMercadoPago } from "@mercadopago/sdk-react";
import axios from "axios";

const PaymentButton = ({ compraId }) => {
  const token = localStorage.getItem("Token");

  const config = {
    headers: {
      xtoken: `${token}`,
    },
  };

  const [preferenceId, setPreferenceId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    initMercadoPago("APP_USR-b715bcab-c79b-422b-bb05-676b98fee41b");

    const crearPreferencia = async () => {
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACK_URL}/api/pagos/crear-preferencia`,
          { compraId },
          config
        );
        if (data.url.preferenceId !== preferenceId) {
          setPreferenceId(data.url.preferenceId);
        }
      } catch (error) {
        console.error("Error al crear la preferencia de pago:", error);
      } finally {
        setLoading(false);
      }
    };

    if (compraId && !preferenceId) {
      crearPreferencia();
    }
  }, [compraId, preferenceId]);

  return (
    <>
      {loading ? (
        <div style={{ textAlign: "center", padding: "1rem" }}>Cargando...</div>
      ) : (
        preferenceId && <Wallet initialization={{ preferenceId }} />
      )}
    </>
  );
};

export default PaymentButton;
